import React from "react";
import { CheckCircle2Icon, GlobeIcon, LockIcon, ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
import { MOCKUP_IMAGE, offerIncludes, valueStack } from "../../data/offer";
export function OfferSection() {
  return <section id="offer" className="w-full bg-surface px-4 py-16 sm:px-5 sm:py-24" data-id="element-254" data-mp="aia3kn3azx0t">
      <div className="mx-auto max-w-3xl" data-id="element-255" data-mp="6hztozce4mgo">
        <div className="text-center" data-id="element-256" data-mp="6j13z1ll14xc">
          <p className="inline-block rounded-full bg-danger px-4 py-1.5 text-xs font-black uppercase tracking-[0.14em] text-white sm:text-sm" data-id="element-257" data-mp="1q85gvgpistp">
            Special Launch Offer
          </p>
          <h2 className="mt-4 text-[28px] font-black leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-258" data-mp="3ny7wogvf9j2t">
            Here's Everything You'll Receive Today
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl bg-white shadow-card ring-2 ring-brand/30" data-id="element-259" data-mp="3ex9u830mtjmc">
          <img src={MOCKUP_IMAGE} alt="Complete Self-Ligating Orthodontics Blueprint collection" className="mx-auto w-full max-w-lg px-4 pt-6" data-id="element-260" data-mp="1asabfly1fi3j" />

          <div className="px-5 pb-8 pt-4 sm:px-10" data-id="element-261" data-mp="10u4dfffcqw3y">
            <ul className="divide-y divide-navy-900/10" data-id="element-262" data-mp="10vfj5kscydxp">
              {valueStack.map(row => <li key={row.detail} className="flex items-center justify-between gap-4 py-3.5" data-id="element-263" data-mp="15tgwrq70ll1s">
                  <div className="min-w-0" data-id="element-264" data-mp="1tj1iuhygsyfa">
                    <p className="text-xs font-black uppercase tracking-wider text-brand" data-id="element-265" data-mp="1yhcu8x4ergzm">{row.label}</p>
                    <p className="text-[15px] font-bold leading-snug text-ink" data-id="element-266" data-mp="1ki3mmlu9pv79">{row.detail}</p>
                  </div>
                  <span className="shrink-0 text-base font-extrabold text-ink-muted line-through" data-id="element-267" data-mp="1oinlpuyej8w1">{row.value}</span>
                </li>)}
            </ul>

            <div className="mt-2 flex items-center justify-between rounded-2xl bg-navy-900 px-5 py-4" data-id="element-268" data-mp="d4a2j3elfhmc">
              <span className="text-sm font-black uppercase tracking-wider text-white" data-id="element-269" data-mp="2fqnsvlh07456">Total Reference Value</span>
              <span className="text-xl font-black text-white/70 line-through" data-id="element-270" data-mp="2arax2b85mmqg">$244 USD</span>
            </div>

            <div className="mt-8 text-center" data-id="element-271" data-mp="2602k557m8j8j">
              <p className="text-lg font-bold text-ink-muted" data-id="element-272" data-mp="25z1b16a5u6tg">
                But you don't have to pay <span className="line-through" data-id="element-273" data-mp="20zye694c36wk">$244</span>.
                <br data-id="element-274" data-mp="1x1h5hl59lod1" />
                And you don't have to pay <span className="line-through" data-id="element-275" data-mp="1wycw89cy02fi">$97</span>.
              </p>
              <p className="mt-5 text-sm font-extrabold uppercase tracking-wider text-ink" data-id="element-276" data-mp="1rzru24e4r8of">
                Today you can get the complete collection for:
              </p>
              <p className="mt-2 text-7xl font-black leading-none tracking-tight text-brand sm:text-8xl" data-id="element-277" data-mp="1i3yfkfgup540">
                $27<span className="ml-1 text-2xl font-black text-ink sm:text-3xl" data-id="element-278" data-mp="3hezn7j0mx8yw">USD</span>
              </p>
              <p className="mt-2 text-sm font-black uppercase tracking-[0.16em] text-success" data-id="element-279" data-mp="3cihiuk97vcn3">One-Time Payment</p>
            </div>

            <ul className="mx-auto mt-7 grid max-w-xl gap-2.5 sm:grid-cols-2" data-id="element-280" data-mp="3kwdwuc6uz2ca">
              {offerIncludes.map(item => <li key={item} className="flex items-center gap-2.5 text-[15px] font-semibold text-ink" data-id="element-281" data-mp="3tqs6nz8mdko0">
                  <CheckCircle2Icon className="h-5 w-5 shrink-0 text-success" aria-hidden="true" data-id="element-282" data-mp="2kqu1m90aj09" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-8" data-id="element-283" data-mp="360y01zew8sc7">
              <ScarcityBar data-id="element-284" data-mp="361z9y0k6b8sc" />
            </div>

            <div className="mt-6 flex flex-col items-center gap-3 text-center" data-id="element-285" data-mp="3630owg4b8ffc">
              <CtaButton label="Yes! Get My Self-Ligating Blueprint™" className="sm:w-full" data-id="element-286" data-mp="3aypoukk8ryc6" />
              <p className="flex items-center gap-1.5 text-xs font-medium text-ink-muted sm:text-sm" data-id="element-287" data-mp="3g0otdxrpx1ap">
                <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-288" data-mp="q9junw0kpf17" />
                Only $27 USD · One-Time Payment · Instant Digital Access
              </p>
            </div>

            <div className="mt-6 rounded-2xl border-2 border-dashed border-danger/30 bg-white p-5" data-id="element-289" data-mp="246mie9wddt2u">
              <p className="mb-3 text-center text-sm font-extrabold uppercase tracking-wider text-ink" data-id="element-290" data-mp="1z81sp4eqursn">Your Special Offer</p>
              <Countdown data-id="element-291" data-mp="2d7szak2xl5wm" />
            </div>

            <div className="mt-5 flex items-start gap-3 rounded-2xl bg-sky-soft p-4" data-id="element-292" data-mp="286wy4e9yrxuw">
              <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-navy-700" aria-hidden="true" data-id="element-293" data-mp="2n4flbc6zu308" />
              <p className="text-sm leading-snug text-ink" data-id="element-294" data-mp="2i5majrj3cq3r">
                <strong className="font-extrabold" data-id="element-295" data-mp="2i5cf3ofa1qqo">Automatic currency conversion:</strong> the price is converted to your local
                currency automatically at checkout, wherever you are.
              </p>
            </div>

            <div className="mt-6 text-center" data-id="element-296" data-mp="35v6sq87f7jbz">
              <p className="text-lg font-black text-ink" data-id="element-297" data-mp="35vynjgt71d17">Complete Digital Collection — $27 USD</p>
              <p className="text-sm text-ink-muted" data-id="element-298" data-mp="30xeznav1hr67">Start exploring the complete educational system today.</p>
              <p className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-success" data-id="element-299" data-mp="3kif8znfl6eut">
                <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-300" data-mp="3pggt8bor0k7v" />
                7-Day Satisfaction Guarantee
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}